import imageDe from '../images/de/uploader-abbottXtra-problem-2.png';
import imageEn from '../images/en/uploader-abbottXtra-problem-2.png';
import imageEs from '../images/es/uploader-abbottXtra-problem-2.png';
import imageFi from '../images/fi/uploader-abbottXtra-problem-2.png';
import imageFr from '../images/fr/uploader-abbottXtra-problem-2.png';
import imageIt from '../images/it/uploader-abbottXtra-problem-2.png';
import imageNo from '../images/no/uploader-abbottXtra-problem-2.png';
import imageSv from '../images/sv/uploader-abbottXtra-problem-2.png';

export const uploaderTryAgainImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
